import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  updates: [],
};

export const AuditTrailSlices = createSlice({
  name: "updates",
  initialState,
  reducers: {
    getUpdatedData: (state, action) => {
      const arr = [];
      state.updates = action.payload;
    },
  },
});

export const { getUpdatedData } = AuditTrailSlices.actions;

export default AuditTrailSlices.reducer;
